import { mergeSxProps, Pill } from "@clipboard-health/ui-components";
import { Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

export interface PayoutFeePillsProps {
  fee: number;
  sx?: SxProps<Theme>;
}

function getPillLabels(fee: number): string[] {
  if (fee <= 0) {
    return ["No fee"];
  }

  return [`${formatDollarsAsUsd(fee)} fee per payout`, "No fee for second shift in a double"];
}

export function PayoutFeePills(props: PayoutFeePillsProps) {
  const { fee, sx } = props;

  return (
    <Stack
      direction="row"
      gap={1}
      sx={mergeSxProps(
        {
          flexWrap: "wrap",
          alignItems: "center",
        },
        sx
      )}
    >
      {getPillLabels(fee).map((label) => (
        <Pill key={label} label={label} size="small" />
      ))}
    </Stack>
  );
}
